import { render, staticRenderFns } from "./ProcessingAnswers.vue?vue&type=template&id=f5598f18&scoped=true&"
import script from "./ProcessingAnswers.vue?vue&type=script&lang=js&"
export * from "./ProcessingAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5598f18",
  null
  
)

export default component.exports